import { i18nConfig } from '@flex-packages/i18n-base';
import languageDetector from 'next-language-detector';

/**
 * https://github.com/i18next/next-language-detector
 */

export const getLanguageCode = (lang: string) => {
  switch (lang) {
    case 'ko':
    case 'ko-KR':
      return 'ko';
    default:
      return 'en';
  }
};

export default languageDetector({
  supportedLngs: [...i18nConfig.i18n.locales, 'ko-KR', 'en-US'],
  fallbackLng: i18nConfig.i18n.defaultLocale,
  order: ['navigator', 'cookie'],
});
